import _Input from "hzero-ui/lib/input";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "style", "className", "onFocus", "onBlur"];
import React, { forwardRef, useState, useCallback } from "react";
import styled from "styled-components";
import "./css";
var StyledInputContainer = styled.div.withConfig({
  displayName: "Input__StyledInputContainer",
  componentId: "sc-19dnl4b-0"
})(["display:inline-block;width:100%;padding:0;margin:0;line-height:0;position:relative;box-sizing:border-box;.ant-calendar-picker{width:100%;}"]);
export var getRequiredInputComponent = function getRequiredInputComponent(Component) {
  var extraClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var isTextarea = arguments.length > 2 ? arguments[2] : undefined;
  return forwardRef(function (props, ref) {
    var disabled = props.disabled,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      className = props.className,
      _props$onFocus = props.onFocus,
      onFocus = _props$onFocus === void 0 ? function () {} : _props$onFocus,
      _props$onBlur = props.onBlur,
      onBlur = _props$onBlur === void 0 ? function () {} : _props$onBlur,
      rest = _objectWithoutProperties(props, _excluded);
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];
    var passedProps = _objectSpread(_objectSpread({}, rest), {}, {
      disabled: disabled
    });
    var handleComponentFocus = useCallback(function () {
      onFocus.apply(void 0, arguments);
      setFocused(function (f) {
        return !f;
      });
    }, []);
    var handleComponentBlur = useCallback(function () {
      onBlur.apply(void 0, arguments);
      setFocused(function (f) {
        return !f;
      });
    }, []);
    var containerClassNames = ["themed-input-wrapper", extraClass, disabled ? " t-field-disabled" : "", focused ? "t-field-focused" : "", className];
    var passedStyle = _objectSpread({}, style || {});
    if (isTextarea) {
      passedStyle.minHeight = passedStyle.height || "auto";
      passedStyle.height = "auto";
    }
    return /*#__PURE__*/React.createElement(StyledInputContainer, {
      style: passedStyle,
      className: containerClassNames.join(" ")
    }, /*#__PURE__*/React.createElement("span", {
      className: "themed-input-inner".concat(disabled ? " t-field-disabled-inner" : "")
    }, /*#__PURE__*/React.createElement(Component, Object.assign({}, passedProps, {
      ref: ref,
      onFocus: handleComponentFocus,
      onBlur: handleComponentBlur
    }))));
  });
};
var Input = getRequiredInputComponent(_Input, "t-input");
Object.assign(Input, _Input); // Input.TextArea = getRequiredInputComponent(HInput.TextArea, "t-textarea", true);

Input.Group = _Input.Group;
Input.Search = getRequiredInputComponent(_Input.Search, "t-search");
export default Input;